













import { Vue, Component } from 'vue-property-decorator';
import { ASSET_URL } from '../../../common/config';
import brandModule from '../../../store/modules/brand.module';

@Component
export default class SlideshowView extends Vue {
  cdnUrl = ASSET_URL;

  get bannerImages(): Array<string> {
    if (!brandModule.brand || !brandModule.brand.banner_urls) { return []; }
    return brandModule.brand.banner_urls;
  }
}
